import { render, staticRenderFns } from "./singlePic.vue?vue&type=template&id=b3e47220&"
import script from "./singlePic.vue?vue&type=script&lang=js&"
export * from "./singlePic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports